import { createContext, useContext, useMemo, type ReactNode } from "react";

type TabBarOverrideSetter = (node: ReactNode | null) => void;

type TabBarOverrideContextValue = {
  setOverride: TabBarOverrideSetter;
  openChat: () => void;
};

const TabBarOverrideContext = createContext<TabBarOverrideContextValue>({
  setOverride: () => {},
  openChat: () => {},
});

export function TabBarOverrideProvider({
  children,
  setOverride,
  openChat,
}: {
  children: ReactNode;
  setOverride: TabBarOverrideSetter;
  openChat: () => void;
}) {
  // A stable value keeps a tab-bar override write from re-rendering every
  // screen that reads this context.
  const value = useMemo(
    () => ({ setOverride, openChat }),
    [setOverride, openChat],
  );
  return (
    <TabBarOverrideContext.Provider value={value}>
      {children}
    </TabBarOverrideContext.Provider>
  );
}

export function useTabBarOverride() {
  return useContext(TabBarOverrideContext).setOverride;
}

export function useMainChatOpener() {
  return useContext(TabBarOverrideContext).openChat;
}
